import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({name: 'customdate'})
export class CustomDatePipe implements PipeTransform {
  transform(value: string): string {
    let date = moment(value, ['DD-MM-YY', 'DD/MM/YYYY', 'MM/DD/YYYY']);
    if (date.isValid()) {
      return date.format('DD-MM-YY'); 
    } else {
      return value;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/custom/date.pipe.ts